import React from "react";

const CodeReview = ({className}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="926.62165"
      height="600.08495"
      viewBox="0 0 926.62165 600.08495"
      //xmlns:xlink="http://www.w3.org/1999/xlink"
      role="img"
      artist="Katerina Limpitsouni"
      source="https://undraw.co/"
      className={className}
    >
      <path
        d="M1046.81082,584.50538H405.97232a16.51868,16.51868,0,0,1-16.5-16.5V172.85157a12.10185,12.10185,0,0,1,12.08789-12.08838h649.4535a12.31111,12.31111,0,0,1,12.29711,12.29736V568.00538A16.51867,16.51867,0,0,1,1046.81082,584.50538Z"
        transform="translate(-136.68918 -149.95753)"
        fill="#f2f2f2"
      />
      <path
        d="M1026.091,563.67306H428.84627c-8.755,0-15.87757-6.66993-15.87757-14.86817v-344.105c0-6.08008,5.278-11.02685,11.76563-11.02685H1030.008c6.59521,0,11.96069,5.02832,11.96069,11.20849V548.80489C1041.9687,557.00313,1034.8459,563.67306,1026.091,563.67306Z"
        transform="translate(-136.68918 -149.95753)"
        fill="#fff"
      />
      <path
        d="M1063.08109,174.90772H389.24076v-8.40039a16.57376,16.57376,0,0,1,16.56-16.5498H1046.521a16.57368,16.57368,0,0,1,16.56006,16.5498Z"
        transform="translate(-136.68918 -149.95753)"
        fill="#3f3d56"
      />
      <circle cx="282.64694" cy="12.5" r="4.28342" fill="#fff" />
      <circle cx="298.90575" cy="12.5" r="4.28342" fill="#fff" />
      <circle cx="315.16455" cy="12.5" r="4.28342" fill="#fff" />
      <path
        d="M713.29967,268.912H596.49153a6.56614,6.56614,0,0,1,0-13.13228H713.29967a6.56614,6.56614,0,1,1,0,13.13228Z"
        transform="translate(-136.68918 -149.95753)"
        fill="#ccc"
      />
      <path
        d="M858.44587,268.912H741.63774a6.56614,6.56614,0,0,1,0-13.13228H858.44587a6.56614,6.56614,0,1,1,0,13.13228Z"
        transform="translate(-136.68918 -149.95753)"
        fill="#ccc"
      />
      <path
        d="M858.44587,293.79419H655.24119a6.56613,6.56613,0,1,1,0-13.13227H858.44587a6.56613,6.56613,0,1,1,0,13.13227Z"
        transform="translate(-136.68918 -149.95753)"
        fill="#ccc"
      />
      <path
        d="M713.29967,243.68419H596.49153a6.56614,6.56614,0,0,1,0-13.13227H713.29967a6.56614,6.56614,0,1,1,0,13.13227Z"
        transform="translate(-136.68918 -149.95753)"
        fill="#ccc"
      />
      <path
        d="M777.5787,244.02978H744.40243a6.56614,6.56614,0,0,1,0-13.13228H777.5787a6.56614,6.56614,0,1,1,0,13.13228Z"
        transform="translate(-136.68918 -149.95753)"
        fill="#ccc"
      />
      <path
        d="M629.66781,293.79419H596.49153a6.56614,6.56614,0,0,1,0-13.13227h33.17628a6.56614,6.56614,0,1,1,0,13.13227Z"
        transform="translate(-136.68918 -149.95753)"
        fill="#ccc"
      />
      <path
        d="M713.29967,501.912H596.49153a6.56614,6.56614,0,0,1,0-13.13228H713.29967a6.56614,6.56614,0,1,1,0,13.13228Z"
        transform="translate(-136.68918 -149.95753)"
        fill="#ccc"
      />
      <path
        d="M858.44587,501.912H741.63774a6.56614,6.56614,0,0,1,0-13.13228H858.44587a6.56614,6.56614,0,1,1,0,13.13228Z"
        transform="translate(-136.68918 -149.95753)"
        fill="#ccc"
      />
      <path
        d="M858.44587,526.79419H655.24119a6.56613,6.56613,0,1,1,0-13.13227H858.44587a6.56614,6.56614,0,1,1,0,13.13227Z"
        transform="translate(-136.68918 -149.95753)"
        fill="#ccc"
      />
      <path
        d="M713.29967,476.68419H596.49153a6.56613,6.56613,0,0,1,0-13.13227H713.29967a6.56613,6.56613,0,1,1,0,13.13227Z"
        transform="translate(-136.68918 -149.95753)"
        fill="#ccc"
      />
      <path
        d="M777.5787,477.02978H744.40243a6.56614,6.56614,0,0,1,0-13.13228H777.5787a6.56614,6.56614,0,0,1,0,13.13228Z"
        transform="translate(-136.68918 -149.95753)"
        fill="#ccc"
      />
      <path
        d="M629.66781,526.79419H596.49153a6.56613,6.56613,0,0,1,0-13.13227h33.17628a6.56614,6.56614,0,1,1,0,13.13227Z"
        transform="translate(-136.68918 -149.95753)"
        fill="#ccc"
      />
      <path
        d="M682.793,431.41924a9.39692,9.39692,0,0,1-6.62352-2.7101l-43.90868-43.35929a9.1516,9.1516,0,0,1,0-13.02336l43.73124-43.18435a9.70171,9.70171,0,0,1,13.64354.043h0a9.689,9.689,0,0,1,.00019,13.68669l-32.49607,32.49664a5.41338,5.41338,0,0,0,0,7.64652l32.31978,32.32016a9.418,9.418,0,0,1-6.66648,16.08412Z"
        transform="translate(-136.68918 -149.95753)"
        fill="#2C55E5"
      />
      <path
        d="M752.75859,431.41924a9.418,9.418,0,0,1-6.66648-16.08412L778.41189,383.015a5.41338,5.41338,0,0,0,0-7.64652L745.91582,342.8718a9.67776,9.67776,0,0,1,.00019-13.68669h0a9.70169,9.70169,0,0,1,13.64353-.043l43.73124,43.18435a9.15157,9.15157,0,0,1,0,13.02336l-43.90867,43.35929A9.39891,9.39891,0,0,1,752.75859,431.41924Z"
        transform="translate(-136.68918 -149.95753)"
        fill="#2C55E5"
      />
    </svg>
  );
};

export default CodeReview;
